const selectRoot = (state) => state.connectCards;

export const selectConnectCard = (hash) => (state) => {
  const { data, loading } = selectRoot(state);
  return {
    data: data[hash],
    loading,
  };
};
